/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {FsTranslate} from '../model/fsTranslate';
import {SelectItem} from '../model/selectItem';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorI18nCacheService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Ajouter un code traduction dans le cache
     * Cette requête permet d&#39;ajouter un code traduction dans le cache s&#39;il n&#39;existe pas déjà dans l&#39;API d&#39;Airiane.
     * @param typeCode Le type de code (ville, pays, aeroport, etc...)
     * @param code Un ou plusieurs codes abrégé des différents données de système
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addIfNotExistFromAirianeUsingPOST(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', code?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public addIfNotExistFromAirianeUsingPOST(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', code?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public addIfNotExistFromAirianeUsingPOST(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', code?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public addIfNotExistFromAirianeUsingPOST(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', code?: Array<string>, observe: any = 'body', reportProgress = false): Observable<any> {

        if (typeCode === null || typeCode === undefined) {
            throw new Error('Required parameter typeCode was null or undefined when calling addIfNotExistFromAirianeUsingPOST.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (code) {
            code.forEach((element) => {
                queryParameters = queryParameters.append('code', <any> element);
            });
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<any>(`${this.basePath}/api/i18-cache/fs/${encodeURIComponent(String(typeCode))}`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprimer la traduction
     * Cette requête permet de supprimer la traduction par type de code (ville, pays, aeroport, etc...) si jamais on lui fournit ces données.&lt;br&gt;Si non, on supprime la traduction partout dans le cache.
     * @param typeCode Le type de code (ville, pays, aeroport, etc...)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteUsingDELETE(typeCode?: Array<'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT'>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteUsingDELETE(typeCode?: Array<'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT'>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteUsingDELETE(typeCode?: Array<'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT'>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteUsingDELETE(typeCode?: Array<'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT'>, observe: any = 'body', reportProgress = false): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (typeCode) {
            typeCode.forEach((element) => {
                queryParameters = queryParameters.append('typeCode', <any> element);
            });
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.delete<any>(`${this.basePath}/api/i18-cache/fs/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getByKey
     *
     * @param typeCode typeCode
     * @param onlyEnable onlyEnable
     * @param key key
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getByKeyUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, observe?: 'body', reportProgress?: boolean): Observable<SelectItem>;
    public getByKeyUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SelectItem>>;
    public getByKeyUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SelectItem>>;
    public getByKeyUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (typeCode === null || typeCode === undefined) {
            throw new Error('Required parameter typeCode was null or undefined when calling getByKeyUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        queryParameters = queryParameters.set('onlyEnable', onlyEnable);
        if (key !== undefined && key !== null) {
            queryParameters = queryParameters.set('key', <any> key);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<SelectItem>(`${this.basePath}/api/i18-cache/fs/value/${encodeURIComponent(String(typeCode))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getDialCode
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDialCodeUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public getDialCodeUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public getDialCodeUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public getDialCodeUsingGET(observe: any = 'body', reportProgress = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<string>>(`${this.basePath}/api/i18-cache/client/dialcode`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getTemplate
     *
     *
     * @param idPartTJ idPartTJ
     * @param productType productType
     * @param templateTJ templateTJ
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTemplateUsingGET(idPartTJ: 'AV' | 'BES' | 'BVE' | 'BZR' | 'CFR' | 'CRL' | 'DOL' | 'LIG' | 'LIL' | 'MPL' | 'RDZ' | 'UIP' | 'URO' | 'ZZZ', templateTJ: 'AFTERWORD' | 'CROSS_SELL' | 'FOOTER' | 'HEADER' | 'INFOS', observe?: 'body', reportProgress?: boolean): Observable<string>;
    public getTemplateUsingGET(idPartTJ: 'AV' | 'BES' | 'BVE' | 'BZR' | 'CFR' | 'CRL' | 'DOL' | 'LIG' | 'LIL' | 'MPL' | 'RDZ' | 'UIP' | 'URO' | 'ZZZ', templateTJ: 'AFTERWORD' | 'CROSS_SELL' | 'FOOTER' | 'HEADER' | 'INFOS', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public getTemplateUsingGET(idPartTJ: 'AV' | 'BES' | 'BVE' | 'BZR' | 'CFR' | 'CRL' | 'DOL' | 'LIG' | 'LIL' | 'MPL' | 'RDZ' | 'UIP' | 'URO' | 'ZZZ', templateTJ: 'AFTERWORD' | 'CROSS_SELL' | 'FOOTER' | 'HEADER' | 'INFOS', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public getTemplateUsingGET(idPartTJ: 'AV' | 'BES' | 'BVE' | 'BZR' | 'CFR' | 'CRL' | 'DOL' | 'LIG' | 'LIL' | 'MPL' | 'RDZ' | 'UIP' | 'URO' | 'ZZZ', templateTJ: 'AFTERWORD' | 'CROSS_SELL' | 'FOOTER' | 'HEADER' | 'INFOS', observe: any = 'body', reportProgress = false): Observable<any> {


        if (idPartTJ === null || idPartTJ === undefined) {
            throw new Error('Required parameter idPartTJ was null or undefined when calling getTemplateUsingGET.');
        }

        const productType = 'FLIGHTS';

        if (templateTJ === null || templateTJ === undefined) {
            throw new Error('Required parameter templateTJ was null or undefined when calling getTemplateUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (idPartTJ !== undefined && idPartTJ !== null) {
            queryParameters = queryParameters.set('idPartTJ', <any> idPartTJ);
        }
        if (templateTJ !== undefined && templateTJ !== null) {
            queryParameters = queryParameters.set('templateTJ', <any> templateTJ);
        }

        let headers = this.defaultHeaders;


        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<string>(`${this.basePath}/api/i18-cache/client/template-emailing-mfly/${encodeURIComponent(String(productType))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getTraductionFromAiriane
     *
     * @param typeCode typeCode
     * @param codes codes
     * @param field field
     * @param isos isos
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTraductionFromAirianeUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', codes?: Array<string>, field?: string, isos?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<FsTranslate>>;
    public getTraductionFromAirianeUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', codes?: Array<string>, field?: string, isos?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FsTranslate>>>;
    public getTraductionFromAirianeUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', codes?: Array<string>, field?: string, isos?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FsTranslate>>>;
    public getTraductionFromAirianeUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', codes?: Array<string>, field?: string, isos?: Array<string>, observe: any = 'body', reportProgress = false): Observable<any> {

        if (typeCode === null || typeCode === undefined) {
            throw new Error('Required parameter typeCode was null or undefined when calling getTraductionFromAirianeUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (codes) {
            codes.forEach((element) => {
                queryParameters = queryParameters.append('codes', <any> element);
            })
        }
        if (field !== undefined && field !== null) {
            queryParameters = queryParameters.set('field', <any> field);
        }
        if (isos) {
            isos.forEach((element) => {
                queryParameters = queryParameters.append('isos', <any> element);
            })
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<FsTranslate>>(`${this.basePath}/api/i18-cache/fs/${encodeURIComponent(String(typeCode))}/airiane-api`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * refreshAffilie
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public refreshAffilieUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public refreshAffilieUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public refreshAffilieUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public refreshAffilieUsingPUT(observe: any = 'body', reportProgress = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<any>(`${this.basePath}/api/i18-cache/client/AFFILIE`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * refreshTraduction
     *
     * @param typeCode typeCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public refreshTraductionUsingPUT(typeCode?: Array<'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT'>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public refreshTraductionUsingPUT(typeCode?: Array<'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT'>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public refreshTraductionUsingPUT(typeCode?: Array<'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT'>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public refreshTraductionUsingPUT(typeCode?: Array<'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT'>, observe: any = 'body', reportProgress = false): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (typeCode) {
            typeCode.forEach((element) => {
                queryParameters = queryParameters.append('typeCode', <any> element);
            });
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<any>(`${this.basePath}/api/i18-cache/fs/`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchClientToMap
     *
     *
     * @param key key
     * @param q q
     * @param value value
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchClientToMapUsingGET(key?: string, q?: string, value?: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: string; }>;
    public searchClientToMapUsingGET(key?: string, q?: string, value?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: string; }>>;
    public searchClientToMapUsingGET(key?: string, q?: string, value?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: string; }>>;
    public searchClientToMapUsingGET(key?: string, q?: string, value?: string, observe: any = 'body', reportProgress = false): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (key !== undefined && key !== null) {
            queryParameters = queryParameters.set('key', <any> key);
        }
        if (q !== undefined && q !== null) {
            queryParameters = queryParameters.set('q', <any> q);
        }
        if (value !== undefined && value !== null) {
            queryParameters = queryParameters.set('value', <any> value);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<{ [key: string]: string; }>(`${this.basePath}/api/i18-cache/client/map/AFFILIE`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchClient
     *
     *
     * @param key key
     * @param q q
     * @param value value
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchClientUsingGET(key?: string, q?: string, value?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SelectItem>>;
    public searchClientUsingGET(key?: string, q?: string, value?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SelectItem>>>;
    public searchClientUsingGET(key?: string, q?: string, value?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SelectItem>>>;
    public searchClientUsingGET(key?: string, q?: string, value?: string, observe: any = 'body', reportProgress = false): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (key !== undefined && key !== null) {
            queryParameters = queryParameters.set('key', <any> key);
        }
        if (q !== undefined && q !== null) {
            queryParameters = queryParameters.set('q', <any> q);
        }
        if (value !== undefined && value !== null) {
            queryParameters = queryParameters.set('value', <any> value);
        }

        let headers = this.defaultHeaders;


        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<SelectItem>>(`${this.basePath}/api/i18-cache/client/array/AFFILIE`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchToMap
     *
     *
     * @param typeCode typeCode
     * @param onlyEnable onlyEnable
     * @param key key
     * @param q q
     * @param value value
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchToMapUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, q?: string, value?: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: string; }>;
    public searchToMapUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, q?: string, value?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: string; }>>;
    public searchToMapUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, q?: string, value?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: string; }>>;
    public searchToMapUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, q?: string, value?: string, observe: any = 'body', reportProgress = false): Observable<any> {


        if (typeCode === null || typeCode === undefined) {
            throw new Error('Required parameter typeCode was null or undefined when calling searchToMapUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        queryParameters = queryParameters.set('onlyEnable', onlyEnable);
        if (key !== undefined && key !== null) {
            queryParameters = queryParameters.set('key', <any> key);
        }
        if (q !== undefined && q !== null) {
            queryParameters = queryParameters.set('q', <any> q);
        }
        if (value !== undefined && value !== null) {
            queryParameters = queryParameters.set('value', <any> value);
        }

        let headers = this.defaultHeaders;


        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<{ [key: string]: string; }>(`${this.basePath}/api/i18-cache/fs/map/${encodeURIComponent(String(typeCode))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * search
     *
     *
     * @param typeCode typeCode
     * @param key key
     * @param q q
     * @param value value
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, q?: string, value?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SelectItem>>;
    public searchUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, q?: string, value?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SelectItem>>>;
    public searchUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, q?: string, value?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SelectItem>>>;
    public searchUsingGET(typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', onlyEnable: boolean, key?: string, q?: string, value?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (typeCode === null || typeCode === undefined) {
            throw new Error('Required parameter typeCode was null or undefined when calling searchUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        queryParameters = queryParameters.set('onlyEnable', onlyEnable);
        if (key !== undefined && key !== null) {
            queryParameters = queryParameters.set('key', <any> key);
        }
        if (q !== undefined && q !== null) {
            queryParameters = queryParameters.set('q', <any> q);
        }
        if (value !== undefined && value !== null) {
            queryParameters = queryParameters.set('value', <any> value);
        }

        let headers = this.defaultHeaders;


        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<SelectItem>>(`${this.basePath}/api/i18-cache/fs/array/${encodeURIComponent(String(typeCode))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
